var _circle, _g, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGear1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vintage-metal-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#b87333",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    style: {
      stopColor: "#704214",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#4a2c20",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "neon-glow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    style: {
      stopColor: "#ffcc00",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    fill: "url(#vintage-metal-gradient)",
    stroke: "#333333",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#neon-glow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 6,
    transform: "rotate(0 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 6,
    transform: "rotate(30 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 6,
    transform: "rotate(60 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 6,
    transform: "rotate(90 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 6,
    transform: "rotate(120 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 6,
    transform: "rotate(150 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 6,
    transform: "rotate(180 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 6,
    transform: "rotate(210 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 6,
    transform: "rotate(240 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 6,
    transform: "rotate(270 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 6,
    transform: "rotate(300 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 6,
    transform: "rotate(330 50 50)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30,
    fill: "rgba(184, 115, 51, 0.5)",
    stroke: "#4B3621",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 20,
    fill: "rgba(255, 204, 153, 0.2)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 6,
    fill: "url(#neon-glow)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 50,
    r: 2,
    fill: "#ffcc00"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 50,
    r: 2,
    fill: "#ffcc00"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 35,
    r: 2,
    fill: "#ffcc00"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 65,
    r: 2,
    fill: "#ffcc00"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 45,
    stroke: "rgba(255, 204, 153, 0.2)",
    strokeWidth: 0.5,
    fill: "none"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 42,
    stroke: "rgba(255, 204, 153, 0.1)",
    strokeWidth: 0.5,
    fill: "none"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 10,
    fill: "none",
    stroke: "#704214",
    strokeWidth: 1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -8,
    width: 2,
    height: 16,
    fill: "#4a2c20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -1,
    width: 16,
    height: 2,
    fill: "#4a2c20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5.5,
    y: -5.5,
    width: 11,
    height: 11,
    transform: "rotate(45)",
    fill: "none",
    stroke: "#704214",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear1);
export default __webpack_public_path__ + "static/media/gear1.43d7833927408ea88b31046ab30f4601.svg";
export { ForwardRef as ReactComponent };